
export const examenes_item = [
    {
        "nombre" : "2025",
        "url" : "/pdf/Resultados/Aprobados2025.pdf",
       
    },
    {
        "nombre" : "2024",
        "url" : "/pdf/Resultados/Aprobados2024.pdf",
     
    },
  
]

